import { Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const CurrencyDisplay = ({ currencySignPosition, currencySign, children, }) => {
    return currencySignPosition === 'after' ? (_jsxs(_Fragment, { children: [children, currencySign] })) : (_jsxs(_Fragment, { children: [currencySign, children] }));
};
//# sourceMappingURL=index.js.map